/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useMemo, useContext, createContext } from 'react'
import { useGLTF, Merged } from '@react-three/drei'

const context = createContext()
export const Instances = React.memo(function Instances({ children, ...props }) {
  const { nodes } = useGLTF('/models/Gateway_Lunar_SpaceStation_v2.glb')
  const instances = useMemo(
    () => ({
      MaxarPPEArrayORIGINALPT: nodes['Maxar_PPE_Array_01-ORIGINAL_PT01'],
      MaxarHETORIGINALPT: nodes.Maxar_HET_01_ORIGINAL_PT01,
      MaxarPPEThrusterPT: nodes.Maxar_PPE_Thruster_PT01,
      MaxarPPEThrusterPT1: nodes.Maxar_PPE_Thruster002_PT01,
      MaxarPPEThrusterPT2: nodes.Maxar_PPE_Thruster004_PT01,
      MaxarPPEThrusterPT3: nodes.Maxar_PPE_Thruster005_PT01,
      NGHALOSatDishORIGINALPT: nodes.NG_HALOSatDish_01_ORIGINAL_PT02,
      NGHALOGripORIGINALPT: nodes.NG_HALO_Grip_01_ORIGINAL_PT02,
      NGHALOGripsOriginalPT: nodes.NG_HALO_Grips_Original_PT02,
      NGHALOLargePlateORIGINALPT: nodes.NG_HALO_LargePlate_01_ORIGINAL_PT02,
      NGHALOPlateORIGINALPT: nodes.NG_HALO_Plate_01_ORIGINAL_PT02,
      NGHALOThrustersORIGINALPT: nodes.NG_HALO_Thrusters_01_ORIGINAL_PT02,
      NDSportactivehatchDUPLICATEPT: nodes.NDS_port_active_hatch_02_DUPLICATE_PT02,
      AirlockBoxLargeORIGINALPT: nodes.Airlock_Box_Large_01_ORIGINAL_PT02,
      AirlockBoxSmallORIGINALPT: nodes.Airlock_Box_Small_01_ORIGINAL_PT02,
      AirlockCamORIGINALPT: nodes.Airlock_Cam_01_ORIGINAL_PT02,
      AirlockGripORIGINALPT: nodes.Airlock_Grip_01_ORIGINAL_PT02,
      AirlockGripMiddleORIGINALPT: nodes.Airlock_Grip_Middle_01_ORIGINAL_PT02,
      AirlockLongGripORIGINALPT: nodes.Airlock_LongGrip_01_ORIGINAL_PT02,
      AirlockLowerGripORIGINALPT: nodes.Airlock_LowerGrip_01_ORIGINAL_PT02,
      AirlockradiatorORIGINALPT: nodes['Airlock_radiator01-ORIGINAL_PT02'],
      ERMXLLoResShutterORIGINALPT: nodes.ERMXL_LoRes_Shutter_01_ORIGINAL_PT02,
      ERMXLLoResUnitORIGINALPT: nodes.ERMXL_LoRes_Unit_01_ORIGINAL_PT02,
      NDSportpassiveORIGINALPT: nodes.NDS_port_passive_ORIGINAL_PT02,
      IHabRadiatorORIGINALPT: nodes['I-Hab_Radiator01-ORIGINAL_PT01'],
      IHabAdditionSmallORIGINALPT: nodes['I-Hab_Addition_Small_01_ORIGINAL_PT01'],
      IHabBoxOriginalPT: nodes['I-Hab_Box_01_Original_PT01'],
      IHabLongGripORIGINALPT: nodes['I-Hab_LongGrip_01_ORIGINAL_PT01'],
      NDSShutterORIGINALPT: nodes.NDS_Shutter001_ORIGINAL_PT01,
    }),
    [nodes]
  )

  return (
    <Merged castShadow receiveShadow meshes={instances} {...props}>
      {(instances) => <context.Provider value={instances} children={children} />}
    </Merged>
  )
})

export const Model = React.memo(function Model(props) {
  const instances = useContext(context)
  const { nodes, materials } = useGLTF('/models/Gateway_Lunar_SpaceStation_v2.glb')

  return (
    <group {...props} dispose={null}>
      <group name="Scene" position={[-4.617, 0, 0]}>
        <mesh
          name="Maxar_PPE001_PT01"
          castShadow
          receiveShadow
          geometry={nodes.Maxar_PPE001_PT01.geometry}
          material={materials.Gateway_01}
        />
        <instances.MaxarPPEArrayORIGINALPT
          castShadow
          receiveShadow
          name="Maxar_PPE_Array_01-ORIGINAL_PT01"
          position={[-2.755, 0, 0]}
        />
        <instances.MaxarHETORIGINALPT
          castShadow
          receiveShadow
          name="Maxar_HET_01_ORIGINAL_PT01"
        />
        <instances.MaxarPPEThrusterPT
          castShadow
          receiveShadow
          name="Maxar_PPE_Thruster_PT01"
        />
        <instances.MaxarPPEThrusterPT1
          castShadow
          receiveShadow
          name="Maxar_PPE_Thruster002_PT01"
        />
        <instances.MaxarPPEThrusterPT2
          castShadow
          receiveShadow
          name="Maxar_PPE_Thruster004_PT01"
        />
        <instances.MaxarPPEThrusterPT3
          castShadow
          receiveShadow
          name="Maxar_PPE_Thruster005_PT01"
        />
        <mesh
          name="NG_HALO001_PT02"
          castShadow
          receiveShadow
          geometry={nodes.NG_HALO001_PT02.geometry}
          material={materials.Gateway_01}
          position={[-0.003, 0, 0]}
          rotation={[0, 1.571, 0]}
        />
        <mesh
          name="NG_HALO002_PT02"
          castShadow
          receiveShadow
          geometry={nodes.NG_HALO002_PT02.geometry}
          material={materials.Gateway_01}
          position={[-0.003, 0, 0]}
          rotation={[0, 1.571, 0]}
        />
        <instances.NGHALOSatDishORIGINALPT
          castShadow
          receiveShadow
          name="NG_HALOSatDish_01_ORIGINAL_PT02"
          position={[6.518, 1.409, 0.911]}
          rotation={[0, 1.571, 0]}
        />
        <instances.NGHALOGripORIGINALPT
          castShadow
          receiveShadow
          name="NG_HALO_Grip_01_ORIGINAL_PT02"
          position={[-0.003, 0, 0]}
          rotation={[0, 1.571, 0]}
        />
        <instances.NGHALOGripsOriginalPT
          castShadow
          receiveShadow
          name="NG_HALO_Grips_Original_PT02"
          position={[-0.003, 0, 0]}
          rotation={[0, 1.571, 0]}
        />
        <instances.NGHALOLargePlateORIGINALPT
          castShadow
          receiveShadow
          name="NG_HALO_LargePlate_01_ORIGINAL_PT02"
          position={[-0.003, 0, 0]}
          rotation={[0, 1.571, 0]}
        />
        <instances.NGHALOPlateORIGINALPT
          castShadow
          receiveShadow
          name="NG_HALO_Plate_01_ORIGINAL_PT02"
          position={[-0.003, 0, 0]}
          rotation={[0, 1.571, 0]}
        />
        <instances.NGHALOThrustersORIGINALPT
          castShadow
          receiveShadow
          name="NG_HALO_Thrusters_01_ORIGINAL_PT02"
          position={[-0.003, 0, 0]}
          rotation={[0, 1.571, 0]}
        />
        <instances.MaxarHETORIGINALPT
          castShadow
          receiveShadow
          name="Maxar_HET_02_DUPLICATE_PT01" position={[0, 0, 1.043]} />
        <instances.MaxarHETORIGINALPT
          castShadow
          receiveShadow
          name="Maxar_HET_03_DUPLICATE_PT01" position={[0, 0, 2.086]} />
        <instances.MaxarPPEArrayORIGINALPT
          castShadow
          receiveShadow
          name="Maxar_PPE_Array_02-DUPLICATE_PT01"
          position={[-2.755, 0, 0]}
          rotation={[-Math.PI, 0, 0]}
        />
        <instances.MaxarPPEThrusterPT2
          castShadow
          receiveShadow
          name="Maxar_PPE_Thruster006_DUPLICATE"
          rotation={[Math.PI, 0, 0]}
        />
        <instances.MaxarPPEThrusterPT3
          castShadow
          receiveShadow
          name="Maxar_PPE_Thruster007_DUPLICATE"
          rotation={[Math.PI, 0, 0]}
        />
        <instances.MaxarPPEThrusterPT
          castShadow
          receiveShadow
          name="Maxar_PPE_Thruster001_DUPLICATE"
          rotation={[-Math.PI, 0, 0]}
        />
        <instances.MaxarPPEThrusterPT1
          castShadow
          receiveShadow
          name="Maxar_PPE_Thruster003_DUPLICATE"
          rotation={[Math.PI, 0, 0]}
        />
        <instances.NGHALOSatDishORIGINALPT
          castShadow
          receiveShadow
          name="NG_HALOSatDish_02_Duplicate_PT02"
          position={[6.52, 1.468, -0.794]}
          rotation={[-1.222, 1.57, 0]}
        />
        <instances.NGHALOGripORIGINALPT
          castShadow
          receiveShadow
          name="NG_HALO_Grip_02_DUPLICATE_PT02"
          position={[1.2, 0, 0]}
          rotation={[0, 1.571, 0]}
        />
        <instances.NGHALOGripORIGINALPT
          castShadow
          receiveShadow
          name="NG_HALO_Grip_03_DUPLICATE_PT02"
          position={[2.35, 0, 0]}
          rotation={[0, 1.571, 0]}
        />
        <instances.NGHALOGripORIGINALPT
          castShadow
          receiveShadow
          name="NG_HALO_Grip_04_DUPLICATE_PT02"
          position={[3.24, 0, 0]}
          rotation={[0, 1.571, 0]}
        />
        <instances.NGHALOGripORIGINALPT
          castShadow
          receiveShadow
          name="NG_HALO_Grip_05_DUPLICATE_PT02"
          position={[4.45, 0, 0]}
          rotation={[0, 1.571, 0]}
        />
        <instances.NGHALOGripORIGINALPT
          castShadow
          receiveShadow
          name="NG_HALO_Grip_06_DUPLICATE_PT02"
          position={[-0.003, 0, 0]}
          rotation={[-Math.PI / 2, Math.PI / 2, 0]}
        />
        <instances.NGHALOGripORIGINALPT
          castShadow
          receiveShadow
          name="NG_HALO_Grip_07_DUPLICATE_PT02"
          position={[-0.003, 0, 0]}
          rotation={[Math.PI / 2, Math.PI / 2, 0]}
        />
        <instances.NGHALOGripORIGINALPT
          castShadow
          receiveShadow
          name="NG_HALO_Grip_08_DUPLICATE001_PT02"
          position={[2.35, 0, 0]}
          rotation={[Math.PI, 1.571, 0]}
        />
        <instances.NGHALOGripORIGINALPT
          castShadow
          receiveShadow
          name="NG_HALO_Grip_08_DUPLICATE_PT02"
          position={[1.2, 0, 0]}
          rotation={[-2.356, 1.571, 0]}
        />
        <instances.NGHALOGripsOriginalPT
          castShadow
          receiveShadow
          name="NG_HALO_Grips_Duplicate001_PT02"
          position={[-0.003, 0, 0]}
          rotation={[Math.PI / 8, 1.571, 0]}
        />
        <instances.NGHALOGripsOriginalPT
          castShadow
          receiveShadow
          name="NG_HALO_Grips_Duplicate002_PT02"
          position={[-0.004, 0.002, -0.002]}
          rotation={[Math.PI / 4, 1.571, 0]}
        />
        <instances.NGHALOGripsOriginalPT
          castShadow
          receiveShadow
          name="NG_HALO_Grips_Duplicate003_PT02"
          position={[-0.004, 0.002, -0.002]}
          rotation={[1.178, 1.57, 0]}
        />
        <instances.NGHALOGripsOriginalPT
          castShadow
          receiveShadow
          name="NG_HALO_Grips_Duplicate004_PT02"
          position={[-0.004, 0.002, -0.002]}
          rotation={[Math.PI / 2, Math.PI / 2, 0]}
        />
        <instances.NGHALOGripsOriginalPT
          castShadow
          receiveShadow
          name="NG_HALO_Grips_Duplicate005_PT02"
          position={[-0.004, 0.002, -0.002]}
          rotation={[1.963, Math.PI / 2, 0]}
        />
        <instances.NGHALOGripsOriginalPT
          castShadow
          receiveShadow
          name="NG_HALO_Grips_Duplicate006_PT02"
          position={[-0.004, 0.002, -0.002]}
          rotation={[2.356, 1.571, 0]}
        />
        <instances.NGHALOGripsOriginalPT
          castShadow
          receiveShadow
          name="NG_HALO_Grips_Duplicate007_PT02"
          position={[-0.004, 0.002, -0.002]}
          rotation={[2.749, Math.PI / 2, 0]}
        />
        <instances.NGHALOGripsOriginalPT
          castShadow
          receiveShadow
          name="NG_HALO_Grips_Duplicate008_PT02"
          position={[-0.004, 0.002, -0.002]}
          rotation={[Math.PI, 1.571, 0]}
        />
        <instances.NGHALOGripsOriginalPT
          castShadow
          receiveShadow
          name="NG_HALO_Grips_Duplicate009_PT02"
          position={[-0.004, 0.002, -0.002]}
          rotation={[-2.749, Math.PI / 2, 0]}
        />
        <instances.NGHALOGripsOriginalPT
          castShadow
          receiveShadow
          name="NG_HALO_Grips_Duplicate010_PT02"
          position={[-0.004, 0.002, -0.002]}
          rotation={[-2.356, Math.PI / 2, 0]}
        />
        <instances.NGHALOGripsOriginalPT
          castShadow
          receiveShadow
          name="NG_HALO_Grips_Duplicate011_PT02"
          position={[-0.004, 0.002, -0.002]}
          rotation={[-1.963, 1.571, 0]}
        />
        <instances.NGHALOGripsOriginalPT
          castShadow
          receiveShadow
          name="NG_HALO_Grips_Duplicate012_PT02"
          position={[-0.004, 0.002, -0.002]}
          rotation={[-Math.PI / 2, Math.PI / 2, 0]}
        />
        <instances.NGHALOGripsOriginalPT
          castShadow
          receiveShadow
          name="NG_HALO_Grips_Duplicate013_PT02"
          position={[-0.004, 0.002, -0.002]}
          rotation={[-1.178, 1.571, 0]}
        />
        <instances.NGHALOGripsOriginalPT
          castShadow
          receiveShadow
          name="NG_HALO_Grips_Duplicate014_PT02"
          position={[-0.004, 0.002, -0.002]}
          rotation={[-Math.PI / 4, Math.PI / 2, 0]}
        />
        <instances.NGHALOGripsOriginalPT
          castShadow
          receiveShadow
          name="NG_HALO_Grips_Duplicate015_PT02"
          position={[-0.004, 0.002, -0.002]}
          rotation={[-Math.PI / 8, 1.571, 0]}
        />
        <instances.NGHALOLargePlateORIGINALPT
          castShadow
          receiveShadow
          name="NG_HALO_LargePlate_02_DUPLICATE_PT02"
          position={[-0.003, 0, 0]}
          rotation={[-Math.PI / 4, 1.571, 0]}
        />
        <instances.NGHALOLargePlateORIGINALPT
          castShadow
          receiveShadow
          name="NG_HALO_LargePlate_03_DUPLICATE_PT02"
          position={[-0.003, 0, 0]}
          rotation={[Math.PI, 1.571, 0]}
        />
        <instances.NGHALOLargePlateORIGINALPT
          castShadow
          receiveShadow
          name="NG_HALO_LargePlate_04_DUPLICATE_PT02"
          position={[-0.003, 0, 0]}
          rotation={[2.356, Math.PI / 2, 0]}
        />
        <instances.NGHALOPlateORIGINALPT
          castShadow
          receiveShadow
          name="NG_HALO_Plate_02_DUPLICATE_PT02"
          position={[-0.003, 0, 0]}
          rotation={[Math.PI / 4, 1.57, 0]}
        />
        <instances.NGHALOPlateORIGINALPT
          castShadow
          receiveShadow
          name="NG_HALO_Plate_03_DUPLICATE_PT02"
          position={[-0.003, 0, 0]}
          rotation={[Math.PI / 2, Math.PI / 2, 0]}
        />
        <instances.NGHALOPlateORIGINALPT
          castShadow
          receiveShadow
          name="NG_HALO_Plate_04_DUPLICATE_PT02"
          position={[-0.003, 0, 0]}
          rotation={[2.356, 1.571, 0]}
        />
        <instances.NGHALOPlateORIGINALPT
          castShadow
          receiveShadow
          name="NG_HALO_Plate_05_DUPLICATE_PT02"
          position={[-0.003, 0, 0]}
          rotation={[-Math.PI, 1.571, 0]}
        />
        <instances.NGHALOPlateORIGINALPT
          castShadow
          receiveShadow
          name="NG_HALO_Plate_06_DUPLICATE_PT02"
          position={[-0.003, 0, 0]}
          rotation={[-2.356, 1.571, 0]}
        />
        <instances.NGHALOPlateORIGINALPT
          castShadow
          receiveShadow
          name="NG_HALO_Plate_07_DUPLICATE_PT02"
          position={[-0.003, 0, 0]}
          rotation={[-Math.PI / 2, Math.PI / 2, 0]}
        />
        <mesh
          name="NG_HALO_Plate_08_DUPLICATE_PT02"
          castShadow
          receiveShadow
          geometry={nodes.NG_HALO_Plate_08_DUPLICATE_PT02.geometry}
          material={materials.Gatewaye_02}
          position={[-0.003, 0, 0]}
          rotation={[-Math.PI / 4, 1.571, 0]}
        />
        <instances.NGHALOPlateORIGINALPT
          castShadow
          receiveShadow
          name="NG_HALO_Plate_09_DUPLICATE_PT02"
          position={[1.193, 0, 0]}
          rotation={[0, 1.571, 0]}
        />
        <instances.NGHALOPlateORIGINALPT
          castShadow
          receiveShadow
          name="NG_HALO_Plate_10_DUPLICATE_PT02"
          position={[1.193, 0, 0]}
          rotation={[Math.PI / 4, 1.571, 0]}
        />
        <instances.NGHALOPlateORIGINALPT
          castShadow
          receiveShadow
          name="NG_HALO_Plate_11_DUPLICATE_PT02"
          position={[1.193, 0, 0]}
          rotation={[Math.PI / 2, Math.PI / 2, 0]}
        />
        <instances.NGHALOPlateORIGINALPT
          castShadow
          receiveShadow
          name="NG_HALO_Plate_12_DUPLICATE_PT02"
          position={[1.193, 0, 0]}
          rotation={[2.356, 1.571, 0]}
        />
        <instances.NGHALOPlateORIGINALPT
          castShadow
          receiveShadow
          name="NG_HALO_Plate_13_DUPLICATE_PT02"
          position={[1.193, 0, 0]}
          rotation={[-Math.PI, 1.571, 0]}
        />
        <instances.NGHALOPlateORIGINALPT
          castShadow
          receiveShadow
          name="NG_HALO_Plate_14_DUPLICATE_PT02"
          position={[1.193, 0, 0]}
          rotation={[-2.356, Math.PI / 2, 0]}
        />
        <instances.NGHALOPlateORIGINALPT
          castShadow
          receiveShadow
          name="NG_HALO_Plate_15_DUPLICATE_PT02"
          position={[1.193, 0, 0]}
          rotation={[-Math.PI / 2, Math.PI / 2, 0]}
        />
        <instances.NGHALOPlateORIGINALPT
          castShadow
          receiveShadow
          name="NG_HALO_Plate_16_DUPLICATE_PT02"
          position={[1.193, 0, 0]}
          rotation={[-Math.PI / 4, Math.PI / 2, 0]}
        />
        <instances.NGHALOPlateORIGINALPT
          castShadow
          receiveShadow
          name="NG_HALO_Plate_17_DUPLICATE_PT02"
          position={[4.467, 0, 0]}
          rotation={[Math.PI / 4, 1.571, 0]}
        />
        <instances.NGHALOPlateORIGINALPT
          castShadow
          receiveShadow
          name="NG_HALO_Plate_18_DUPLICATE_PT02"
          position={[4.467, 0, 0]}
          rotation={[Math.PI / 2, Math.PI / 2, 0]}
        />
        <instances.NGHALOPlateORIGINALPT
          castShadow
          receiveShadow
          name="NG_HALO_Plate_19_DUPLICATE_PT02"
          position={[4.467, 0, 0]}
          rotation={[2.356, 1.571, 0]}
        />
        <instances.NGHALOPlateORIGINALPT
          castShadow
          receiveShadow
          name="NG_HALO_Plate_20_DUPLICATE_PT02"
          position={[4.467, 0, 0]}
          rotation={[-Math.PI, 1.571, 0]}
        />
        <instances.NGHALOPlateORIGINALPT
          castShadow
          receiveShadow
          name="NG_HALO_Plate_21_DUPLICATE_PT02"
          position={[4.467, 0, 0]}
          rotation={[-2.356, Math.PI / 2, 0]}
        />
        <instances.NGHALOPlateORIGINALPT
          castShadow
          receiveShadow
          name="NG_HALO_Plate_22_DUPLICATE_PT02"
          position={[4.467, 0, 0]}
          rotation={[-Math.PI / 2, Math.PI / 2, 0]}
        />
        <instances.NGHALOThrustersORIGINALPT
          castShadow
          receiveShadow
          name="NG_HALO_Thrusters_02_DUPLICATE_PT02"
          position={[-0.003, 0, 0]}
          rotation={[Math.PI / 2, Math.PI / 2, 0]}
        />
        <instances.NGHALOThrustersORIGINALPT
          castShadow
          receiveShadow
          name="NG_HALO_Thrusters_03_DUPLICATE001_PT02"
          position={[3.247, 0, 0]}
          rotation={[Math.PI / 2, Math.PI / 2, 0]}
        />
        <instances.NGHALOThrustersORIGINALPT
          castShadow
          receiveShadow
          name="NG_HALO_Thrusters_03_DUPLICATE_PT02"
          position={[3.247, 0, 0]}
          rotation={[0, 1.571, 0]}
        />
        <instances.NDSportactivehatchDUPLICATEPT
          castShadow
          receiveShadow
          name="NDS_port_active_hatch_02_DUPLICATE_PT02"
          position={[4.445, 0, -4.985]}
          rotation={[Math.PI / 2, 0, Math.PI / 2]}
          scale={0.01}
        />
        <mesh
          name="Airlock_PT02"
          castShadow
          receiveShadow
          geometry={nodes.Airlock_PT02.geometry}
          material={materials.Gatewaye_02}
          position={[11.974, 0, -2.01]}
          rotation={[0, 1.571, 0]}
        />
        <instances.AirlockBoxLargeORIGINALPT
          castShadow
          receiveShadow
          name="Airlock_Box_Large_01_ORIGINAL_PT02"
          position={[11.974, 0, -2.01]}
          rotation={[0, 1.571, 0]}
        />
        <instances.AirlockBoxSmallORIGINALPT
          castShadow
          receiveShadow
          name="Airlock_Box_Small_01_ORIGINAL_PT02"
          position={[11.974, 0, -2.01]}
          rotation={[0, 1.571, 0]}
        />
        <instances.AirlockCamORIGINALPT
          castShadow
          receiveShadow
          name="Airlock_Cam_01_ORIGINAL_PT02"
          position={[11.974, 0, -2.01]}
          rotation={[0, 1.571, 0]}
        />
        <instances.AirlockGripORIGINALPT
          castShadow
          receiveShadow
          name="Airlock_Grip_01_ORIGINAL_PT02"
          position={[11.974, 0, -2.01]}
          rotation={[0, 1.571, 0]}
        />
        <instances.AirlockGripORIGINALPT
          castShadow
          receiveShadow
          name="Airlock_Grip_01_ORIGINAL_reverse_PT02"
          position={[11.974, 0, -9.028]}
          rotation={[0, -1.571, 0]}
        />
        <instances.AirlockGripMiddleORIGINALPT
          castShadow
          receiveShadow
          name="Airlock_Grip_Middle_01_ORIGINAL_PT02"
          position={[11.974, 0, -2.01]}
          rotation={[0, 1.571, 0]}
        />
        <instances.AirlockGripMiddleORIGINALPT
          castShadow
          receiveShadow
          name="Airlock_Grip_Middle_01_ORIGINAL001_PT02"
          position={[11.974, 0, -3.21]}
          rotation={[-Math.PI / 2, Math.PI / 8, Math.PI / 2]}
        />
        <instances.AirlockGripMiddleORIGINALPT
          castShadow
          receiveShadow
          name="Airlock_Grip_Middle_01_ORIGINAL002_PT02"
          position={[11.974, 0, -4.23]}
          rotation={[0, 1.571, 0]}
        />
        <instances.AirlockLongGripORIGINALPT
          castShadow
          receiveShadow
          name="Airlock_LongGrip_01_ORIGINAL_PT02"
          position={[11.974, 0, -2.01]}
          rotation={[0, 1.571, 0]}
        />
        <instances.AirlockLongGripORIGINALPT
          castShadow
          receiveShadow
          name="Airlock_LongGrip_01_ORIGINAL001_PT02"
          position={[11.974, 0, -3.2]}
          rotation={[-Math.PI / 2, Math.PI / 4, Math.PI / 2]}
        />
        <instances.AirlockLongGripORIGINALPT
          castShadow
          receiveShadow
          name="Airlock_LongGrip_01_ORIGINAL002_PT02"
          position={[11.974, 0, -4.07]}
          rotation={[-Math.PI / 2, Math.PI / 4, Math.PI / 2]}
        />
        <instances.AirlockLongGripORIGINALPT
          castShadow
          receiveShadow
          name="Airlock_LongGrip_01_ORIGINAL003_PT02"
          position={[11.974, 0, -2.01]}
          rotation={[Math.PI / 2, 0, -Math.PI / 2]}
        />
        <instances.AirlockLowerGripORIGINALPT
          castShadow
          receiveShadow
          name="Airlock_LowerGrip_01_ORIGINAL_PT02"
          position={[11.974, -3.236, -3.895]}
          rotation={[0, 1.571, 0]}
        />
        <instances.AirlockradiatorORIGINALPT
          castShadow
          receiveShadow
          name="Airlock_radiator01-ORIGINAL_PT02"
          position={[11.971, 0, -7.947]}
          rotation={[0, 1.571, 0]}
        />
        <mesh
          name="NDS_Shutter_hinge005_PT02"
          castShadow
          receiveShadow
          geometry={nodes.NDS_Shutter_hinge005_PT02.geometry}
          material={materials.Gatewaye_02}
          position={[11.974, 0, -2.001]}
          rotation={[Math.PI, -1.571, 0]}
          scale={0.01}
        />
        <mesh
          name="ERMXL_LoRes_PT02"
          castShadow
          receiveShadow
          geometry={nodes.ERMXL_LoRes_PT02.geometry}
          material={materials.Gatewaye_02}
          position={[4.445, 0, -5.324]}
          rotation={[0, 1.571, 0]}
        />
        <instances.ERMXLLoResShutterORIGINALPT
          castShadow
          receiveShadow
          name="ERMXL_LoRes_Shutter_01_ORIGINAL_PT02"
          position={[4.445, 0, -5.324]}
          rotation={[0, 1.571, 0]}
        />
        <instances.ERMXLLoResUnitORIGINALPT
          castShadow
          receiveShadow
          name="ERMXL_LoRes_Unit_01_ORIGINAL_PT02"
          position={[4.409, -0.084, -6.787]}
          rotation={[0, 1.571, 0]}
        />
        <instances.NDSportpassiveORIGINALPT
          castShadow
          receiveShadow
          name="NDS_port_passive_ORIGINAL_PT02"
          position={[4.445, 0, -1.833]}
          rotation={[Math.PI / 2, 0, -Math.PI / 2]}
          scale={0.01}
        />
        <mesh
          name="NDS_Shutter_hinge004_PT02"
          castShadow
          receiveShadow
          geometry={nodes.NDS_Shutter_hinge004_PT02.geometry}
          material={materials.Gatewaye_02}
          position={[4.445, 0, -1.833]}
          rotation={[Math.PI / 2, 0, -Math.PI / 2]}
          scale={0.01}
        />
        <mesh
          name="Big_Arm_1_PT02"
          castShadow
          receiveShadow
          geometry={nodes.Big_Arm_1_PT02.geometry}
          material={materials.Gatewaye_02}
          position={[3.77, 1.606, -0.314]}
          rotation={[-0.209, -Math.PI / 2, 0]}
        />
        <instances.NDSportactivehatchDUPLICATEPT
          castShadow
          receiveShadow
          name="NDS_port_active_hatch_01_ORIGINAL_PT02"
          position={[4.445, 0, 4.99]}
          rotation={[Math.PI / 2, 0, -Math.PI / 2]}
          scale={0.01}
        />
        <instances.IHabRadiatorORIGINALPT
          castShadow
          receiveShadow
          name="I-Hab_Radiator01-ORIGINAL_PT01"
          position={[13.758, 0, 0]}
        />
        <instances.IHabAdditionSmallORIGINALPT
          castShadow
          receiveShadow
          name="I-Hab_Addition_Small_01_ORIGINAL_PT01"
          position={[8.261, 0, 0]}
        />
        <instances.IHabBoxOriginalPT
          castShadow
          receiveShadow
          name="I-Hab_Box_01_Original_PT01" position={[8.261, 0, 0]} />
        <instances.IHabLongGripORIGINALPT
          castShadow
          receiveShadow
          name="I-Hab_LongGrip_01_ORIGINAL_PT01"
          position={[8.261, 0, 0]}
        />
        <mesh
          name="I-Hab_PT01"
          castShadow
          receiveShadow
          geometry={nodes['I-Hab_PT01'].geometry}
          material={materials.Gatewaye_02}
          position={[8.261, 0, 0]}
        />
        <mesh
          name="Little_Arm_PT01"
          castShadow
          receiveShadow
          geometry={nodes.Little_Arm_PT01.geometry}
          material={materials.Gatewaye_02}
          position={[15.546, -0.799, 2.322]}
          rotation={[2.531, 1.571, 0]}
        />
        <instances.NDSShutterORIGINALPT
          castShadow
          receiveShadow
          name="NDS_Shutter001_ORIGINAL_PT01"
          position={[11.974, -0.927, 1.967]}
          rotation={[-2.966, -1.571, 0]}
        />
        <mesh
          name="NDS_Shutter_hinge001_PT01"
          castShadow
          receiveShadow
          geometry={nodes.NDS_Shutter_hinge001_PT01.geometry}
          material={materials.Gatewaye_02}
          position={[11.975, 0, 2.024]}
          rotation={[Math.PI, -1.571, 0]}
          scale={0.01}
        />
        <mesh
          name="NDS_Shutter_hinge002_PT01"
          castShadow
          receiveShadow
          geometry={nodes.NDS_Shutter_hinge002_PT01.geometry}
          material={materials.Gatewaye_02}
          position={[11.989, 0, -2.023]}
          rotation={[Math.PI, 1.571, 0]}
          scale={0.01}
        />
        <mesh
          name="NDS_Shutter_hinge003_PT01"
          castShadow
          receiveShadow
          geometry={nodes.NDS_Shutter_hinge003_PT01.geometry}
          material={materials.Gatewaye_02}
          position={[7.496, 0, 0]}
          rotation={[Math.PI / 2, 0, 0]}
          scale={0.01}
        />
        <instances.AirlockBoxLargeORIGINALPT
          castShadow
          receiveShadow
          name="Airlock_Box_Large_02_DUPLICATE_PT02"
          position={[11.974, 0, -2.01]}
          rotation={[Math.PI / 2, Math.PI / 4, -Math.PI / 2]}
        />
        <instances.AirlockBoxSmallORIGINALPT
          castShadow
          receiveShadow
          name="Airlock_Box_Small_02_DUPLICATE001_PT02"
          position={[11.974, 0, -2.01]}
          rotation={[-Math.PI / 2, -1.283, 1.571]}
        />
        <instances.AirlockBoxSmallORIGINALPT
          castShadow
          receiveShadow
          name="Airlock_Box_Small_02_DUPLICATE_PT02"
          position={[11.974, 0, -2.01]}
          rotation={[Math.PI / 2, -0.794, -Math.PI / 2]}
        />
        <instances.AirlockBoxSmallORIGINALPT
          castShadow
          receiveShadow
          name="Airlock_Box_Small_03_DUPLICATE_PT02"
          position={[11.974, 0, -3.01]}
          rotation={[0, 1.571, 0]}
        />
        <instances.AirlockCamORIGINALPT
          castShadow
          receiveShadow
          name="Airlock_Cam_02_DUPLICATE_PT02"
          position={[11.974, 0, -2.01]}
          rotation={[-Math.PI, -1.571, 0]}
        />
        <instances.AirlockGripORIGINALPT
          castShadow
          receiveShadow
          name="Airlock_Grip_02_DUPLICATE001_PT02"
          position={[11.974, 0, -9.028]}
          rotation={[-Math.PI / 2, -1.178, -Math.PI / 2]}
        />
        <instances.AirlockGripORIGINALPT
          castShadow
          receiveShadow
          name="Airlock_Grip_02_DUPLICATE_PT02"
          position={[11.974, 0, -2.01]}
          rotation={[-Math.PI / 2, 1.178, Math.PI / 2]}
        />
        <instances.AirlockGripORIGINALPT
          castShadow
          receiveShadow
          name="Airlock_Grip_03_DUPLICATE001_PT02"
          position={[11.974, 0, -9.028]}
          rotation={[-Math.PI / 2, -Math.PI / 4, -Math.PI / 2]}
        />
        <instances.AirlockGripORIGINALPT
          castShadow
          receiveShadow
          name="Airlock_Grip_03_DUPLICATE_PT02"
          position={[11.974, 0, -2.01]}
          rotation={[-Math.PI / 2, Math.PI / 4, Math.PI / 2]}
        />
        <instances.AirlockGripORIGINALPT
          castShadow
          receiveShadow
          name="Airlock_Grip_04_DUPLICATE001_PT02"
          position={[11.974, 0, -9.028]}
          rotation={[-Math.PI / 2, -Math.PI / 8, -Math.PI / 2]}
        />
        <instances.AirlockGripORIGINALPT
          castShadow
          receiveShadow
          name="Airlock_Grip_04_DUPLICATE_PT02"
          position={[11.974, 0, -2.01]}
          rotation={[-Math.PI / 2, Math.PI / 8, Math.PI / 2]}
        />
        <instances.AirlockGripORIGINALPT
          castShadow
          receiveShadow
          name="Airlock_Grip_05_DUPLICATE001_PT02"
          position={[11.974, 0, -2.01]}
          rotation={[-Math.PI / 2, -Math.PI / 8, Math.PI / 2]}
        />
        <instances.AirlockGripORIGINALPT
          castShadow
          receiveShadow
          name="Airlock_Grip_05_DUPLICATE002_PT02"
          position={[11.974, 0, -9.028]}
          rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
        />
        <instances.AirlockGripORIGINALPT
          castShadow
          receiveShadow
          name="Airlock_Grip_05_DUPLICATE003_PT02"
          position={[11.974, 0, -9.028]}
          rotation={[-Math.PI / 2, Math.PI / 8, -Math.PI / 2]}
        />
        <instances.AirlockGripORIGINALPT
          castShadow
          receiveShadow
          name="Airlock_Grip_05_DUPLICATE_PT02"
          position={[11.974, 0, -2.01]}
          rotation={[-Math.PI / 2, 0, Math.PI / 2]}
        />
        <instances.AirlockGripORIGINALPT
          castShadow
          receiveShadow
          name="Airlock_Grip_06_DUPLICATE001_PT02"
          position={[11.974, 0, -9.028]}
          rotation={[-Math.PI / 2, Math.PI / 4, -Math.PI / 2]}
        />
        <instances.AirlockGripORIGINALPT
          castShadow
          receiveShadow
          name="Airlock_Grip_06_DUPLICATE_PT02"
          position={[11.974, 0, -2.01]}
          rotation={[-Math.PI / 2, -Math.PI / 4, Math.PI / 2]}
        />
        <instances.AirlockGripORIGINALPT
          castShadow
          receiveShadow
          name="Airlock_Grip_07_DUPLICATE001_PT02"
          position={[11.974, 0, -9.028]}
          rotation={[-Math.PI / 2, 1.178, -Math.PI / 2]}
        />
        <instances.AirlockGripORIGINALPT
          castShadow
          receiveShadow
          name="Airlock_Grip_07_DUPLICATE_PT02"
          position={[11.974, 0, -2.01]}
          rotation={[-Math.PI / 2, -1.178, Math.PI / 2]}
        />
        <instances.AirlockGripORIGINALPT
          castShadow
          receiveShadow
          name="Airlock_Grip_08_DUPLICATE001_PT02"
          position={[11.974, 0, -9.028]}
          rotation={[Math.PI, 1.571, 0]}
        />
        <instances.AirlockGripORIGINALPT
          castShadow
          receiveShadow
          name="Airlock_Grip_08_DUPLICATE_PT02"
          position={[11.974, 0, -2.01]}
          rotation={[Math.PI, -1.571, 0]}
        />
        <instances.AirlockGripORIGINALPT
          castShadow
          receiveShadow
          name="Airlock_Grip_09_DUPLICATE001_PT02"
          position={[11.974, 0, -9.028]}
          rotation={[Math.PI / 2, 1.178, Math.PI / 2]}
        />
        <instances.AirlockGripORIGINALPT
          castShadow
          receiveShadow
          name="Airlock_Grip_09_DUPLICATE_PT02"
          position={[11.974, 0, -2.01]}
          rotation={[Math.PI / 2, -1.178, -Math.PI / 2]}
        />
        <instances.AirlockGripORIGINALPT
          castShadow
          receiveShadow
          name="Airlock_Grip_10_DUPLICATE001_PT02"
          position={[11.974, 0, -9.028]}
          rotation={[Math.PI / 2, Math.PI / 4, Math.PI / 2]}
        />
        <instances.AirlockGripORIGINALPT
          castShadow
          receiveShadow
          name="Airlock_Grip_10_DUPLICATE_PT02"
          position={[11.974, 0, -2.01]}
          rotation={[Math.PI / 2, -Math.PI / 4, -Math.PI / 2]}
        />
        <instances.AirlockGripORIGINALPT
          castShadow
          receiveShadow
          name="Airlock_Grip_11_DUPLICATE001_PT02"
          position={[11.974, 0, -9.028]}
          rotation={[Math.PI / 2, Math.PI / 8, Math.PI / 2]}
        />
        <instances.AirlockGripORIGINALPT
          castShadow
          receiveShadow
          name="Airlock_Grip_11_DUPLICATE_PT02"
          position={[11.974, 0, -2.01]}
          rotation={[Math.PI / 2, -Math.PI / 8, -Math.PI / 2]}
        />
        <instances.AirlockGripORIGINALPT
          castShadow
          receiveShadow
          name="Airlock_Grip_12_DUPLICATE001_PT02"
          position={[11.974, 0, -9.028]}
          rotation={[Math.PI / 2, 0, Math.PI / 2]}
        />
        <instances.AirlockGripORIGINALPT
          castShadow
          receiveShadow
          name="Airlock_Grip_12_DUPLICATE_PT02"
          position={[11.974, 0, -2.01]}
          rotation={[Math.PI / 2, 0, -Math.PI / 2]}
        />
        <instances.AirlockGripORIGINALPT
          castShadow
          receiveShadow
          name="Airlock_Grip_13_DUPLICATE001_PT02"
          position={[11.974, 0, -9.028]}
          rotation={[Math.PI / 2, -Math.PI / 8, Math.PI / 2]}
        />
        <instances.AirlockGripORIGINALPT
          castShadow
          receiveShadow
          name="Airlock_Grip_13_DUPLICATE_PT02"
          position={[11.974, 0, -2.01]}
          rotation={[Math.PI / 2, Math.PI / 8, -Math.PI / 2]}
        />
        <instances.AirlockGripORIGINALPT
          castShadow
          receiveShadow
          name="Airlock_Grip_14_DUPLICATE001_PT02"
          position={[11.974, 0, -9.028]}
          rotation={[Math.PI / 2, -Math.PI / 4, Math.PI / 2]}
        />
        <instances.AirlockGripORIGINALPT
          castShadow
          receiveShadow
          name="Airlock_Grip_14_DUPLICATE_PT02"
          position={[11.974, 0, -2.01]}
          rotation={[Math.PI / 2, Math.PI / 4, -Math.PI / 2]}
        />
        <instances.AirlockGripORIGINALPT
          castShadow
          receiveShadow
          name="Airlock_Grip_16_DUPLICATE001_PT02"
          position={[11.974, 0, -9.028]}
          rotation={[Math.PI / 2, -1.178, Math.PI / 2]}
        />
        <instances.AirlockGripORIGINALPT
          castShadow
          receiveShadow
          name="Airlock_Grip_16_DUPLICATE_PT02"
          position={[11.974, 0, -2.01]}
          rotation={[Math.PI / 2, 1.178, -Math.PI / 2]}
        />
        <instances.AirlockGripMiddleORIGINALPT
          castShadow
          receiveShadow
          name="Airlock_Grip_Middle_02_DUPLICATE001_PT02"
          position={[11.974, 0, -3.21]}
          rotation={[-Math.PI / 2, Math.PI / 4, Math.PI / 2]}
        />
        <instances.AirlockGripMiddleORIGINALPT
          castShadow
          receiveShadow
          name="Airlock_Grip_Middle_02_DUPLICATE002_PT02"
          position={[11.974, 0, -4.23]}
          rotation={[Math.PI / 2, 1.178, -Math.PI / 2]}
        />
        <instances.AirlockGripMiddleORIGINALPT
          castShadow
          receiveShadow
          name="Airlock_Grip_Middle_02_DUPLICATE_PT02"
          position={[11.974, 0, -2.01]}
          rotation={[Math.PI / 2, 1.178, -Math.PI / 2]}
        />
        <instances.AirlockGripMiddleORIGINALPT
          castShadow
          receiveShadow
          name="Airlock_Grip_Middle_03_DUPLICATE001_PT02"
          position={[11.974, 0, -3.21]}
          rotation={[-Math.PI / 2, 1.178, Math.PI / 2]}
        />
        <instances.AirlockGripMiddleORIGINALPT
          castShadow
          receiveShadow
          name="Airlock_Grip_Middle_03_DUPLICATE_PT02"
          position={[11.974, 0, -2.01]}
          rotation={[Math.PI / 2, Math.PI / 4, -Math.PI / 2]}
        />
        <instances.AirlockGripMiddleORIGINALPT
          castShadow
          receiveShadow
          name="Airlock_Grip_Middle_04_DUPLICATE_PT02"
          position={[11.974, 0, -2.01]}
          rotation={[Math.PI / 2, Math.PI / 8, -Math.PI / 2]}
        />
        <instances.AirlockGripMiddleORIGINALPT
          castShadow
          receiveShadow
          name="Airlock_Grip_Middle_05_DUPLICATE_PT02"
          position={[11.974, 0, -2.01]}
          rotation={[Math.PI / 2, -0.192, -Math.PI / 2]}
        />
        <instances.AirlockGripMiddleORIGINALPT
          castShadow
          receiveShadow
          name="Airlock_Grip_Middle_06_DUPLICATE001_PT02"
          position={[11.974, 0, -4.23]}
          rotation={[Math.PI / 2, -0.698, -Math.PI / 2]}
        />
        <instances.AirlockGripMiddleORIGINALPT
          castShadow
          receiveShadow
          name="Airlock_Grip_Middle_06_DUPLICATE_PT02"
          position={[11.974, 0, -2.01]}
          rotation={[Math.PI / 2, -Math.PI / 4, -Math.PI / 2]}
        />
        <instances.AirlockGripMiddleORIGINALPT
          castShadow
          receiveShadow
          name="Airlock_Grip_Middle_07_DUPLICATE001_PT02"
          position={[11.974, 0, -4.23]}
          rotation={[Math.PI / 2, -1.091, -Math.PI / 2]}
        />
        <instances.AirlockGripMiddleORIGINALPT
          castShadow
          receiveShadow
          name="Airlock_Grip_Middle_07_DUPLICATE_PT02"
          position={[11.974, 0, -2.01]}
          rotation={[Math.PI / 2, -1.178, -Math.PI / 2]}
        />
        <instances.AirlockGripMiddleORIGINALPT
          castShadow
          receiveShadow
          name="Airlock_Grip_Middle_08_DUPLICATE001_PT02"
          position={[11.974, 0, -4.23]}
          rotation={[Math.PI / 2, -1.484, -Math.PI / 2]}
        />
        <instances.AirlockGripMiddleORIGINALPT
          castShadow
          receiveShadow
          name="Airlock_Grip_Middle_08_DUPLICATE_PT02"
          position={[11.974, 0, -2.01]}
          rotation={[-Math.PI, -1.571, 0]}
        />
        <instances.AirlockGripMiddleORIGINALPT
          castShadow
          receiveShadow
          name="Airlock_Grip_Middle_09_DUPLICATE001_PT02"
          position={[11.974, 0, -4.23]}
          rotation={[-Math.PI / 2, -1.265, Math.PI / 2]}
        />
        <instances.AirlockGripMiddleORIGINALPT
          castShadow
          receiveShadow
          name="Airlock_Grip_Middle_09_DUPLICATE_PT02"
          position={[11.974, 0, -2.01]}
          rotation={[-Math.PI / 2, -1.178, Math.PI / 2]}
        />
        <instances.AirlockGripMiddleORIGINALPT
          castShadow
          receiveShadow
          name="Airlock_Grip_Middle_10_DUPLICATE_PT02"
          position={[11.974, 0, -2.01]}
          rotation={[-Math.PI / 2, -0.593, Math.PI / 2]}
        />
        <instances.AirlockGripMiddleORIGINALPT
          castShadow
          receiveShadow
          name="Airlock_Grip_Middle_11DUPLICATE001_PT02"
          position={[11.974, 0, -3.21]}
          rotation={[-Math.PI / 2, 0, Math.PI / 2]}
        />
        <instances.AirlockGripMiddleORIGINALPT
          castShadow
          receiveShadow
          name="Airlock_Grip_Middle_11DUPLICATE002_PT02"
          position={[11.974, 0, -4.23]}
          rotation={[-Math.PI / 2, 1.178, Math.PI / 2]}
        />
        <instances.AirlockGripMiddleORIGINALPT
          castShadow
          receiveShadow
          name="Airlock_Grip_Middle_11DUPLICATE_PT02"
          position={[11.974, 0, -2.01]}
          rotation={[-Math.PI / 2, 1.178, Math.PI / 2]}
        />
        <instances.AirlockGripMiddleORIGINALPT
          castShadow
          receiveShadow
          name="Airlock_Grip_Middle_12_DUPLICATE001_PT02"
          position={[11.974, 0, -3.21]}
          rotation={[-Math.PI / 2, -Math.PI / 8, Math.PI / 2]}
        />
        <instances.AirlockGripMiddleORIGINALPT
          castShadow
          receiveShadow
          name="Airlock_Grip_Middle_12_DUPLICATE002_PT02"
          position={[11.974, 0, -4.23]}
          rotation={[-Math.PI / 2, Math.PI / 4, Math.PI / 2]}
        />
        <instances.AirlockGripMiddleORIGINALPT
          castShadow
          receiveShadow
          name="Airlock_Grip_Middle_12_DUPLICATE_PT02"
          position={[11.974, 0, -2.01]}
          rotation={[-Math.PI / 2, Math.PI / 4, Math.PI / 2]}
        />
        <instances.AirlockLongGripORIGINALPT
          castShadow
          receiveShadow
          name="Airlock_LongGrip_02_DUPLICATE001_PT02"
          position={[11.974, 0, -2.39]}
          rotation={[Math.PI / 2, -1.484, -Math.PI / 2]}
        />
        <instances.AirlockLongGripORIGINALPT
          castShadow
          receiveShadow
          name="Airlock_LongGrip_02_DUPLICATE002_PT02"
          position={[11.974, 0, -2.38]}
          rotation={[Math.PI / 2, -Math.PI / 4, -Math.PI / 2]}
        />
        <instances.AirlockLongGripORIGINALPT
          castShadow
          receiveShadow
          name="Airlock_LongGrip_02_DUPLICATE003_PT02"
          position={[11.974, 0, -2.79]}
          rotation={[-Math.PI / 2, -Math.PI / 4, Math.PI / 2]}
        />
        <instances.AirlockLongGripORIGINALPT
          castShadow
          receiveShadow
          name="Airlock_LongGrip_02_DUPLICATE004_PT02"
          position={[11.974, 0, -0.64]}
          rotation={[Math.PI / 2, -Math.PI / 4, -Math.PI / 2]}
        />
        <instances.AirlockLongGripORIGINALPT
          castShadow
          receiveShadow
          name="Airlock_LongGrip_02_DUPLICATE005_PT02"
          position={[11.974, 0, 0.23]}
          rotation={[Math.PI / 2, -Math.PI / 4, -Math.PI / 2]}
        />
        <instances.AirlockLongGripORIGINALPT
          castShadow
          receiveShadow
          name="Airlock_LongGrip_02_DUPLICATE_PT02"
          position={[11.974, 0, -2.01]}
          rotation={[-Math.PI / 2, 0, Math.PI / 2]}
        />
        <instances.AirlockLowerGripORIGINALPT
          castShadow
          receiveShadow
          name="Airlock_LowerGrip_02_DUPLICATE_PT02"
          position={[11.974, -3.236, -3.895]}
          rotation={[-Math.PI, 0.384, -Math.PI]}
        />
        <instances.AirlockLowerGripORIGINALPT
          castShadow
          receiveShadow
          name="Airlock_LowerGrip_03_DUPLICATE_PT02"
          position={[11.974, -3.236, -3.895]}
          rotation={[Math.PI, -0.759, Math.PI]}
        />
        <instances.AirlockLowerGripORIGINALPT
          castShadow
          receiveShadow
          name="Airlock_LowerGrip_04_DUPLICATE_PT02"
          position={[11.974, -3.236, -3.895]}
          rotation={[0, Math.PI / 4, 0]}
        />
        <instances.AirlockradiatorORIGINALPT
          castShadow
          receiveShadow
          name="Airlock_radiator02-DUPLICATE_PT02"
          position={[11.971, 0, -7.947]}
          rotation={[Math.PI, -1.571, 0]}
        />
        <instances.ERMXLLoResShutterORIGINALPT
          castShadow
          receiveShadow
          name="ERMXL_LoRes_Shutter_02_DUPLICATE_PT02"
          position={[4.445, 0, -5.324]}
          rotation={[-Math.PI / 2, Math.PI / 6, Math.PI / 2]}
        />
        <instances.ERMXLLoResShutterORIGINALPT
          castShadow
          receiveShadow
          name="ERMXL_LoRes_Shutter_03_DUPLICATE_PT02"
          position={[4.445, 0, -5.324]}
          rotation={[-Math.PI / 2, -Math.PI / 6, Math.PI / 2]}
        />
        <instances.ERMXLLoResShutterORIGINALPT
          castShadow
          receiveShadow
          name="ERMXL_LoRes_Shutter_04_DUPLICATE_PT02"
          position={[4.445, 0, -5.324]}
          rotation={[Math.PI, -1.571, 0]}
        />
        <instances.ERMXLLoResShutterORIGINALPT
          castShadow
          receiveShadow
          name="ERMXL_LoRes_Shutter_05_DUPLICATE_PT02"
          position={[4.445, 0, -5.324]}
          rotation={[Math.PI / 2, -Math.PI / 6, -Math.PI / 2]}
        />
        <instances.ERMXLLoResShutterORIGINALPT
          castShadow
          receiveShadow
          name="ERMXL_LoRes_Shutter_06_DUPLICATE_PT02"
          position={[4.445, 0, -5.324]}
          rotation={[Math.PI / 2, Math.PI / 6, -Math.PI / 2]}
        />
        <instances.ERMXLLoResUnitORIGINALPT
          castShadow
          receiveShadow
          name="ERMXL_LoRes_Unit_02_DUPLICATE_PT02"
          position={[4.485, 0.083, -6.787]}
          rotation={[-Math.PI, -1.571, 0]}
        />
        <instances.NDSportactivehatchDUPLICATEPT
          castShadow
          receiveShadow
          name="NDS_port_active_hatch_03_DUPLICATE_PT02"
          position={[4.445, 0, -1.833]}
          rotation={[Math.PI / 2, 0, -Math.PI / 2]}
          scale={0.01}
        />
        <instances.NDSportactivehatchDUPLICATEPT
          castShadow
          receiveShadow
          name="NDS_port_active_hatch_07_DUPLICATE_PT02"
          position={[11.974, 0, -2.216]}
          rotation={[Math.PI / 2, Math.PI / 6, -Math.PI / 2]}
          scale={0.01}
        />
        <instances.NDSportactivehatchDUPLICATEPT
          castShadow
          receiveShadow
          name="NDS_port_active_hatch_08_DUPLICATE_PT02"
          position={[0.674, 0, 0]}
          rotation={[Math.PI / 2, 0, 0]}
          scale={0.01}
        />
        <instances.NDSportpassiveORIGINALPT
          castShadow
          receiveShadow
          name="NDS_port_passive_DUPLICATE_PT02"
          position={[11.974, 0, -2.001]}
          rotation={[Math.PI / 2, 0, -Math.PI / 2]}
          scale={0.01}
        />
        <instances.NDSShutterORIGINALPT
          castShadow
          receiveShadow
          name="NDS_Shutter004_DUPLICATE_PT02"
          position={[5.372, -0.001, -1.889]}
          rotation={[Math.PI / 2, 0, -1.745]}
        />
        <instances.NDSShutterORIGINALPT
          castShadow
          receiveShadow
          name="NDS_Shutter005_DUPLICATE_PT02"
          position={[11.973, -0.927, -2.058]}
          rotation={[-2.88, -1.571, 0]}
        />
        <instances.AirlockBoxLargeORIGINALPT
          castShadow
          receiveShadow
          name="Airlock_Box_Large_01_DUPLICATE"
          position={[11.974, 0, -2.01]}
          rotation={[-Math.PI / 2, 0, Math.PI / 2]}
        />
        <instances.AirlockBoxLargeORIGINALPT
          castShadow
          receiveShadow
          name="Airlock_Box_Large_01_DUPLICATE001"
          position={[11.377, -2.416, -2.375]}
          rotation={[Math.PI / 2, -0.384, -Math.PI / 2]}
        />
        <instances.IHabRadiatorORIGINALPT
          castShadow
          receiveShadow
          name="I-Hab_Radiator02_DUPLICATE_PT01"
          position={[13.758, 0, 0]}
          rotation={[0, 0, Math.PI]}
        />
        <instances.IHabAdditionSmallORIGINALPT
          castShadow
          receiveShadow
          name="I-Hab_Addition_Small_02_DUPLICATE_PT01"
          position={[8.261, 0, 0]}
          rotation={[-Math.PI, 0, 0]}
        />
        <instances.IHabBoxOriginalPT
          castShadow
          receiveShadow
          name="I-Hab_Box_02_DUPLICATE_PT01"
          position={[8.261, 0, 0]}
          rotation={[Math.PI / 4, 0, 0]}
        />
        <instances.IHabBoxOriginalPT
          castShadow
          receiveShadow
          name="I-Hab_Box_03_DUPLICATE_PT01"
          position={[8.261, 0, 0]}
          rotation={[-Math.PI, 0, 0]}
        />
        <instances.IHabBoxOriginalPT
          castShadow
          receiveShadow
          name="I-Hab_Box_04_DUPLICATE_PT01"
          position={[8.261, 0, 0]}
          rotation={[-2.356, 0, 0]}
        />
        <instances.IHabLongGripORIGINALPT
          castShadow
          receiveShadow
          name="I-Hab_LongGrip_02_DUPLICATE001_PT01"
          position={[8.261, 0, 0]}
          rotation={[-Math.PI / 2, 0, 0]}
        />
        <instances.IHabLongGripORIGINALPT
          castShadow
          receiveShadow
          name="I-Hab_LongGrip_02_DUPLICATE002_PT01"
          position={[8.261, 0, 0]}
          rotation={[-2.304, 0, 0]}
        />
        <instances.IHabLongGripORIGINALPT
          castShadow
          receiveShadow
          name="I-Hab_LongGrip_02_DUPLICATE003_PT01"
          position={[8.261, 0, 0]}
          rotation={[Math.PI, 0, 0]}
        />
        <instances.IHabLongGripORIGINALPT
          castShadow
          receiveShadow
          name="I-Hab_LongGrip_02_DUPLICATE004_PT01"
          position={[8.261, 0, 0]}
          rotation={[2.409, 0, 0]}
        />
        <instances.IHabLongGripORIGINALPT
          castShadow
          receiveShadow
          name="I-Hab_LongGrip_02_DUPLICATE005_PT01"
          position={[8.261, 0, 0]}
          rotation={[0.733, 0, 0]}
        />
        <instances.IHabLongGripORIGINALPT
          castShadow
          receiveShadow
          name="I-Hab_LongGrip_02_DUPLICATE006_PT01"
          position={[8.261, 0, 0]}
          rotation={[Math.PI / 2, 0, 0]}
        />
        <instances.IHabLongGripORIGINALPT
          castShadow
          receiveShadow
          name="I-Hab_LongGrip_02_DUPLICATE_PT01"
          position={[8.261, 0, 0]}
          rotation={[-0.733, 0, 0]}
        />
        <instances.NDSportactivehatchDUPLICATEPT
          castShadow
          receiveShadow
          name="NDS_port_active_hatch_04_DUPLICATE_PT01"
          position={[11.974, 0, -4.821]}
          rotation={[Math.PI / 2, 0, Math.PI / 2]}
          scale={0.01}
        />
        <instances.NDSportactivehatchDUPLICATEPT
          castShadow
          receiveShadow
          name="NDS_port_active_hatch_05_DUPLICATE_PT01"
          position={[8.351, 0, 0]}
          rotation={[2.094, 0, 0]}
          scale={0.01}
        />
        <instances.NDSportactivehatchDUPLICATEPT
          castShadow
          receiveShadow
          name="NDS_port_active_hatch_06_DUPLICATE_PT01"
          position={[11.974, 0, 4.82]}
          rotation={[Math.PI / 2, 0, -Math.PI / 2]}
          scale={0.01}
        />
        <instances.NDSportpassiveORIGINALPT
          castShadow
          receiveShadow
          name="NDS_port_passive_DUPLICATE001_PT01"
          position={[7.496, 0, 0]}
          rotation={[Math.PI / 2, 0, 0]}
          scale={0.01}
        />
        <instances.NDSShutterORIGINALPT
          castShadow
          receiveShadow
          name="NDS_Shutter002_DUPLICATE_PT01"
          position={[11.99, -0.927, -1.967]}
          rotation={[2.967, Math.PI / 2, 0]}
        />
        <instances.NDSShutterORIGINALPT
          castShadow
          receiveShadow
          name="NDS_Shutter003_DUPLICATE_PT01"
          position={[7.553, -0.001, 0.927]}
          rotation={[Math.PI / 2, 0, -0.175]}
        />
      </group>
    </group>
  )
})

